import React from 'react';
import CanvasLink from 'components/chatapp/CanvasLink';

const CANVAS_ID_REGEX = /canvas-([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/gi;

export const parseCanvasLinks = (text: string): React.ReactNode[] => {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;

  CANVAS_ID_REGEX.lastIndex = 0;

  while ((match = CANVAS_ID_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const canvasUuid = match[1];
    const fullCanvasId = match[0];

    parts.push(
      <CanvasLink 
        key={`canvas-${match.index}`} 
        canvasId={canvasUuid}
        className="mx-1"
      >
        {fullCanvasId}
      </CanvasLink>
    );

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? parts : [text];
};

export const extractCanvasIds = (text: string): string[] => {
  const matches = text.match(CANVAS_ID_REGEX);
  if (!matches) return [];
  
  return matches.map(match => match.replace('canvas-', ''));
};
